import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { IMakeCounterofferProps } from 'models/api';

import { asyncPayloadCreator } from 'utils';

export const makeCounteroffer = createAsyncThunk(
	'secondaryMarket/makeCounteroffer',
	(params: IMakeCounterofferProps, { rejectWithValue }) =>
		asyncPayloadCreator(params, { rejectWithValue }, SecondaryMarketService.makeCounteroffer),
);
